import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchGymTransfer,
  fetchGymTransferRequest,
  fetchMembershipTransfer,
  fetchMembershipTransferRequest,
  fetchSegments,
  fetchTransferDetails,
} from "./transferAPIs";

export const fetchGymTransferData = createAsyncThunk(
  "transfer/fetchGymTransferData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymTransfer(filters, token);
    return response;
  }
);

export const fetchMembershipTransferData = createAsyncThunk(
  "transfer/fetchMembershipTransferData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchMembershipTransfer(filters, token);
    return response;
  }
);

export const fetchMembershipTransferRequestData = createAsyncThunk(
  "transfer/fetchMembershipTransferRequestData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchMembershipTransferRequest(filters, token);
    return response;
  }
);

export const fetchGymTransferRequestData = createAsyncThunk(
  "transfer/fetchGymTransferRequestData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymTransferRequest(filters, token);
    return response;
  }
);

export const fetchTransferDetailsData = createAsyncThunk(
  "transfer/fetchTransferDetailsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTransferDetails(filters, token);
    return response;
  }
);

export const fetchSegmentsData = createAsyncThunk(
  "transfer/fetchSegmentsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchSegments(filters, token);
    return response;
  }
);
const transferSlice = createSlice({
  name: "transfer",
  initialState: {
    gymTransferData: null,
    gymTransferLoading: false,
    gymTransferError: null,

    membershipTransferData: null,
    membershipTransferLoading: false,
    membershipTransferError: null,

    membershipTransferRequestData: null,
    membershipTransferRequestLoading: false,
    membershipTransferRequestError: null,

    gymTransferRequestData: null,
    gymTransferRequestLoading: false,
    gymTransferRequestError: null,

    transferDetailsData: null,
    transferDetailsLoading: false,
    transferDetailsError: null,

    segmentsData: null,
    segmentsLoading: false,
    segmentsError: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGymTransferData.pending, (state) => {
        state.gymTransferLoading = true;
        state.gymTransferData = null;
      })
      .addCase(fetchGymTransferData.fulfilled, (state, action) => {
        state.gymTransferLoading = false;
        state.gymTransferData = action.payload;
        state.gymTransferError = null;
      })
      .addCase(fetchGymTransferData.rejected, (state, action) => {
        state.gymTransferLoading = false;
        state.gymTransferData = null;
        state.gymTransferError = action.error.message;
      })

      .addCase(fetchMembershipTransferData.pending, (state) => {
        state.membershipTransferLoading = true;
        state.membershipTransferData = null;
      })
      .addCase(fetchMembershipTransferData.fulfilled, (state, action) => {
        state.membershipTransferLoading = false;
        state.membershipTransferData = action.payload;
        state.membershipTransferError = null;
      })
      .addCase(fetchMembershipTransferData.rejected, (state, action) => {
        state.membershipTransferLoading = false;
        state.membershipTransferData = null;
        state.membershipTransferError = action.error.message;
      })

      .addCase(fetchMembershipTransferRequestData.pending, (state) => {
        state.membershipTransferRequestLoading = true;
        state.membershipTransferRequestData = null;
      })
      .addCase(
        fetchMembershipTransferRequestData.fulfilled,
        (state, action) => {
          state.membershipTransferRequestLoading = false;
          state.membershipTransferRequestData = action.payload;
          state.membershipTransferRequestError = null;
        }
      )
      .addCase(fetchMembershipTransferRequestData.rejected, (state, action) => {
        state.membershipTransferRequestLoading = false;
        state.membershipTransferRequestData = null;
        state.membershipTransferRequestError = action.error.message;
      })

      .addCase(fetchGymTransferRequestData.pending, (state) => {
        state.gymTransferRequestLoading = true;
        state.gymTransferRequestData = null;
      })
      .addCase(fetchGymTransferRequestData.fulfilled, (state, action) => {
        state.gymTransferRequestLoading = false;
        state.gymTransferRequestData = action.payload;
        state.gymTransferRequestError = null;
      })
      .addCase(fetchGymTransferRequestData.rejected, (state, action) => {
        state.gymTransferRequestLoading = false;
        state.gymTransferRequestData = null;
        state.gymTransferRequestError = action.error.message;
      })

      .addCase(fetchTransferDetailsData.pending, (state) => {
        state.transferDetailsLoading = true;
        state.transferDetailsData = null;
      })
      .addCase(fetchTransferDetailsData.fulfilled, (state, action) => {
        state.transferDetailsLoading = false;
        state.transferDetailsData = action.payload;
        state.transferDetailsError = null;
      })
      .addCase(fetchTransferDetailsData.rejected, (state, action) => {
        state.transferDetailsLoading = false;
        state.transferDetailsData = null;
        state.transferDetailsError = action.error.message;
      })

      .addCase(fetchSegmentsData.pending, (state) => {
        state.segmentsLoading = true;
        state.segmentsData = null;
      })
      .addCase(fetchSegmentsData.fulfilled, (state, action) => {
        state.segmentsLoading = false;
        state.segmentsData = action.payload;
        state.segmentsError = null;
      })
      .addCase(fetchSegmentsData.rejected, (state, action) => {
        state.segmentsLoading = false;
        state.segmentsData = null;
        state.segmentsError = action.error.message;
      });
  },
});

export const { resetGymTransferFormState } = transferSlice.actions;

export default transferSlice.reducer;
